import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import trackerItemText from './trackerItemText';
import { replaceVariablesInBrackets } from '../../../../../../utilities/StringHelpers/StringHelpers';
import './tracker.scss';
import { popUpEnum } from './trackerEnum';
import { insertClickToReport } from './DWHReports';
import { prepareUrl } from '../../../../../../utilities/StringHelpers/StringHelpers';
import { abroadInsuranceCreateReportFromTracker } from '../../../../../Block/CollaborationInsuranceBlock/abroadInsurancReports';
import { gaReportAbroadInsurance } from '../../../../../Block/CollaborationInsuranceBlock/abroadInsuranceGA';
import { abroadInsuranceEnum } from '../../../../../Block/CollaborationInsuranceBlock/abroadInsuranceGAEnum';
import { getMarketCode } from '../../../../../../utilities/domain/domainConstants';
const marketCode = getMarketCode()?.toLowerCase();
const whiteArrow = isMobile ? require('./images/layer8.svg') : require('./images/layer-8-copy-11.svg');
const greyArrow = require('./images/grey-arrow.svg');
const purple_bell_gif = require(`./images/bell-${marketCode}.gif`);
const exclamation_mark_gif = require(`./images/Exclamation_Mark_purple-${marketCode}.gif`);

var text = trackerItemText;

const AllUpdatesText = (props) => {
  return (
    <div className='all-updates-container'>
      {isMobile ? (
        <Image src={greyArrow} />
      ) : (
        <>
          {props.updatesNum > 1 && <div>לכל העדכונים ({props.updatesNum})</div>}
          <Image src={greyArrow} />
        </>
      )}
    </div>
  );
};

export const AbroadPackageItem = (props) => {
  const abroadPackage = props.abroadPackage;
  const socSysCreationDate = abroadPackage.socSysCreationDate;
  const socEffDate = abroadPackage.socEffactiveDate;
  const socExpDate = abroadPackage.socExpDate;
  const mobile = props.subscriberNumber;
  let itemText = text.body.abroadPackage;

  function renderDates(effDate, expDate) {
    if (expDate == '01/01/2001' || expDate == '01.01.2001' || expDate == null) {
      return `${effDate}`;
    } else {
      return `מ ${effDate} עד ${expDate}`;
    }
  }

  let neededProps = {
    popUpType: props.popUpType,
    subscriberNumber: props.subscriberNumber,
    id: props.id,
    abroadPackage: props.abroadPackage,

  };

  return (
    <div className='tracker-item' onClick={() => props.onItemClick({ popUpProps: neededProps, popUpType: popUpEnum.ABROAD_PACKAGE })}>
      <div className='tracker-item-main-content'>
        <Image src={purple_bell_gif} className='tracker-gif-item' />
        <div className='tracker-subtitle'>
          <p>{replaceVariablesInBrackets(itemText.title.value, mobile)
            .split('\n')
            .map((str, i) => <p key={i}>{str}</p>)}</p>
        </div>
      </div>
      <AllUpdatesText updatesNum={props.numOfItems}></AllUpdatesText>
    </div>
  );
};

export const ManagerCallItem = (props) => {
  let itemText = text.body.waitingForCall;

  let date = props.callDate;

  return (
    <div className='tracker-item' onClick={() => props.onItemClick({ popUpProps: props, popUpType: props._type })}>
      <div className='tracker-item-main-content'>
        <Image src={purple_bell_gif} className='tracker-gif-item' />
        <div className='tracker-subtitle'>
          <p>{itemText.title.value}</p>
        </div>
      </div>
      <AllUpdatesText updatesNum={props.numOfItems}></AllUpdatesText>
    </div>
  );
};

export const TechnicianVisitItem = (props) => {
  let itemText = text.body.technicianVisit;
  let type = `${window.Config.brand_Name_HE}`;
  if (props.isInfrastructure) {
    type = 'תשתית';
  }
  if (props.isFiber) {
    type = 'פייבר';
  }

  return (
    <div className='tracker-item' onClick={() => props.onItemClick({ popUpProps: props, popUpType: props._type })}>
      <div className='tracker-item-main-content'>
        <Image src={purple_bell_gif} className='tracker-gif-item' />
        <div className='tracker-subtitle'>
          <p style={{ whiteSpace: 'pre' }}>{replaceVariablesInBrackets(itemText.title.value, type)}</p>
        </div>
      </div>
      <AllUpdatesText updatesNum={props.numOfItems}></AllUpdatesText>
    </div>
  );
};

export const AbroadInsuranceItem = (props) => {
  let title = 'יש לך ביטוח נסיעות לחו"ל';
  let dueDate = props.dueDate == null ? '' : props.dueDate.slice(6, 8) + '.' + props.dueDate.slice(4, 6) + '.' + props.dueDate.slice(0, 4);
  useEffect(() => {
    abroadInsuranceCreateReportFromTracker(
      'Ongoing',
      'Insurance Message Displayed',
      dueDate,
      props.name,
      props.ban,
      props.subscriber,
      props.id,
    );
    gaReportAbroadInsurance(abroadInsuranceEnum.ApprovedInsuranceMessage);
  }, []);

  let neededProps = {
    popUpType: props.popUpType,
    dueDate: props.dueDate,
    subscriber: props.subscriber,
    id: props.id
  };

  return (
    <div
      className='tracker-item'
      onClick={() => {
        props.setCurrentSubscriber(props.subscriber),
          prepareUrl(props.abroadInsuranceUrl, props.context),
          abroadInsuranceCreateReportFromTracker(
            'Completed',
            'Insurance Message Clicked',
            dueDate,
            props.name,
            props.ban,
            props.subscriber,
            props.id,
          ),
          gaReportAbroadInsurance(abroadInsuranceEnum.InfoButtonLobby);
        props.onItemClick({ popUpProps: neededProps, popUpType: popUpEnum.ABROAD_INSURANCE })
      }}>
      <div className='tracker-item-main-content'>
        <Image src={purple_bell_gif} className='tracker-gif-item' />
        <div className='tracker-title-and-subtitle'>
          <div className='tracker-subtitle'>{title}</div>
        </div>
      </div>
      <AllUpdatesText updatesNum={props.numOfItems}></AllUpdatesText>
    </div>
  );
};

export const RefundItem = (props) => {
  let itemText = text.body.refund[props.refundStatus];
  let date = props.dueDate;

  return (
    <div className='tracker-item' onClick={() => props.onItemClick({ popUpProps: props, popUpType: popUpEnum.REFUND })}>
      <div className='tracker-item-main-content'>
        <Image src={purple_bell_gif} className='tracker-gif-item' />
        <div className='tracker-title-and-subtitle'>
          <div className='tracker-subtitle'>{itemText.title.value}</div>
        </div>
      </div>
      <AllUpdatesText updatesNum={props.numOfItems}></AllUpdatesText>
    </div>
  );
};

export const FollowUpRefundItem = (props) => {
  let itemText = text.body.followUpRefund[props.refundStatus];

  let date = props.dueDate;

  return (
    <div className='tracker-item' onClick={() => props.onItemClick({ popUpProps: props, popUpType: popUpEnum.FOLLOWUPREFUND })}>
      <div className='tracker-item-main-content'>
        <Image src={purple_bell_gif} className='tracker-gif-item' />
        <div className='tracker-title-and-subtitle'>
          <div className='tracker-subtitle'>{itemText.title.value}</div>
        </div>
      </div>
      <AllUpdatesText updatesNum={props.numOfItems}></AllUpdatesText>
    </div>
  );
};

export const PlanChangeItem = (props) => {
  let itemText = text.body.changePricePlan[props.planChangeType];

  let date = props.dueDate === undefined ? '' : props.dueDate;
  let phone = props.cellularNo === undefined ? '' : props.cellularNo;

  return (
    <div className='tracker-item' onClick={() => props.onItemClick({ popUpProps: props, popUpType: popUpEnum.PLANCHANGE })}>
      <div className='tracker-item-main-content'>
        <Image src={purple_bell_gif} className='tracker-gif-item' />
        <div className='tracker-title-and-subtitle'>
          <div className='tracker-subtitle'>{replaceVariablesInBrackets(itemText.title.value, phone)}</div>
        </div>
      </div>
      <AllUpdatesText updatesNum={props.numOfItems}></AllUpdatesText>
    </div>
  );
};

export const CustomerDeliveriesItem = (props) => {
  const title = text.body.customerDeliveries.title.value;

  return (
    <div className='tracker-item' onClick={() => props.onItemClick({ popUpProps: props, popUpType: popUpEnum.CUSTOMER_DEVLIVERIES })}>
      <div className='tracker-item-main-content'>
        <Image src={purple_bell_gif} className='tracker-gif-item' />
        <div className='tracker-title-and-subtitle'>
          <div className='tracker-subtitle'><p>{replaceVariablesInBrackets(title)
            .split('\n')
            .map((str, i) => (
              <p key={i}>{str}</p>
            ))}</p></div>
        </div>
      </div>
      <AllUpdatesText updatesNum={props.numOfItems}></AllUpdatesText>
    </div>
  );
};

export const FinanceIssueItem = (props) => {
  const financeIssueType = props.banFinanceIssueType;
  const title = props?.URLs?.firstLineText?.value;

  const navigateToPaymentMethodPage = (issueTypeClicked) => {
    let linkTypeClicked = issueTypeClicked.substring(0, 15);
    insertClickToReport(linkTypeClicked);
    props.context.navigateTo(props?.URLs?.paymentMethodIssue?.value?.url);
  };

  const navigateToDebtIssuePage = (issueTypeClicked) => {
    let linkTypeClicked = issueTypeClicked.substring(18);
    insertClickToReport(linkTypeClicked);
    props.context.navigateTo(props?.URLs?.debtIssue?.value?.url);
  };

  let neededProps = {
    popUpType: props.popUpType,
    isFinanceIssue: props.isFinanceIssue,
    banFinanceIssueType: props.banFinanceIssueType,
    URLS: props.URLs,
  };
  return (
    <div
      className='tracker-item'
      onClick={() => {
        props.onItemClick({ popUpProps: neededProps, popUpType: props._type });
      }}>
      <div className='tracker-item-main-content'>
        <Image src={exclamation_mark_gif} className='tracker-gif-item' />
        <div className='tracker-title-and-subtitle'>
          <div className='tracker-subtitle'>
            <p>{title}</p>
          </div>
        </div>
      </div>
      <AllUpdatesText updatesNum={props.numOfItems}></AllUpdatesText>
    </div>
  );
};

export const CouponReceivedItem = (props) => {
  let itemText = text.itemList.couponReceived;
  const couponImage = require('./images/coupon.svg');

  return (
    <div className='tracker-item' onClick={() => props.onItemClick({ popUpProps: props, popUpType: popUpEnum.COUPON_RECEIVED })}>
      <div className='tracker-item-main-content'>
        <Image src={couponImage} className='tracker-coupon-icon' />
        <div className='tracker-title-and-subtitle'>
          <div className='coupon-received-tracker-subtitle'>{replaceVariablesInBrackets(itemText.title.value)}</div>
        </div>
      </div>
      <AllUpdatesText updatesNum={props.numOfItems}></AllUpdatesText>
    </div>
  );
}


